export default "dist/images/block-testimonial-plain.79f8c00.png";